import JobExperience  from ".";

export const jobExperienceRoutes = () => [
  {
    path: "/admin/job-experiences",
    component: JobExperience,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];